import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { getTranslation } from 'common/react/utils/translations';
import { useSelector } from 'react-redux';
import { playerComparisonSelector } from 'common/store/modules/statspro/player-comparison/selectors/simple-selectors';

/**
 * @param {object} props - Props.
 * @param props.children
 * @param props.isFiltersVisibleHandler
 * @param props.setResetFilterBtnStyles
 * @param props.title
 * @returns {JSX.Element} Component.
 */
export const PlayerSelectionFilterItems = ({
    children,
    isFiltersVisibleHandler,
    setResetFilterBtnStyles,
    title
}) => {
    const [resetFns, setResetFns] = useState([]);

    const addOnResetCallback = (resetFn) => {
        setResetFns((fns) => [...fns, resetFn]);
    };

    const resetHandler = (resetFunctions) => {
        setResetFilterBtnStyles(true);
        resetFunctions.forEach((func) => func());
        isFiltersVisibleHandler();
        title ? PULSE.app.tracking.clearFilters(title) : null;
    };

    const { filters } = useSelector(playerComparisonSelector);

    return (
        <>
            {children && (
                <div className="stats-leaders-filters">
                    {React.Children.map(children, (child) => (
                        <div className="stats-leaders-filters__item-wrapper">
                            {React.cloneElement(child, { addOnResetCallback })}
                        </div>
                    ))}
                    {filters.positions.length || filters.teams.length ? (
                        <div className="stats-leaders-filters__item-wrapper stats-leaders-filters__item-wrapper--reset">
                            <button
                                className="stats-leaders-filter-reset-button"
                                onClick={() => resetHandler(resetFns)}
                            >
                                {getTranslation(
                                    'label.statsLeaders.filters.resetButtonText'
                                )}
                            </button>
                        </div>
                    ) : null}
                </div>
            )}
        </>
    );
};

PlayerSelectionFilterItems.defaultProps = {
    name: 'PlayerSelectionFilterItems'
};

PlayerSelectionFilterItems.propTypes = {
    children: PropTypes.any.isRequired,
    isFiltersVisibleHandler: PropTypes.func,
    setResetFilterBtnStyles: PropTypes.func,
    title: PropTypes.string
};
